import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Row
} from "reactstrap";
import SignupFooter from "./SignupFooter";
import Messages from "../../Shared/Messages";
import Text from "../../components/Text";
import RegionSelector from "../RegionSelector";

export default class SignupFacilitySelector extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (this.inputEl) {
      this.inputEl.focus();
    }
  }

  submitForm = e => {
    e.preventDefault();
    let { facilityCode } = this.state;
    if (facilityCode) {
      this.props.submitCode(facilityCode);
    }
  };

  render() {
    let { facilityCode } = this.state;
    let { facilityErrorMessage, facilityError } = this.props;
    return (
      <div className="app flex-column justify-content-center align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6" sm={12}>
              <div className="ob-logos mb-3 justify-content-center my-4">
                <div className="">
                  <img
                    alt="myPatientSpace"
                    src="/img/logo-symbol.png"
                    height={32}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Container>
          <Row className="justify-content-center">
            <Col md="6" sm={12}>
              <CardGroup>
                <Card>
                  <CardBody>
                    <form
                      className="d-flex flex-column"
                      onSubmit={this.submitForm}
                    >
                      <h5 className="mt-3 text-center">
                        <Text content={Messages.invite_only} />
                      </h5>

                      <div className="my-3" style={{ fontSize: "16px" }}>
                        <Text content={Messages.start_entering_code} />
                      </div>

                      {facilityError && (
                        <div>
                          <p className="text-muted">
                            <span style={{ color: "red" }}>
                              {facilityErrorMessage ===
                              "No facility information found for the code given" ? (
                                <Text content={Messages.invalid_code} />
                              ) : (
                                facilityErrorMessage
                              )}
                            </span>
                          </p>
                        </div>
                      )}

                      {/*<div className="mb-3">*/}
                      {/*  <label style={{ fontSize: "20px" }}>*/}
                      {/*    <Text content={Messages.region} />*/}
                      {/*  </label>*/}

                      {/*  <RegionSelector*/}
                      {/*    style={{*/}
                      {/*      fontSize: "20px",*/}
                      {/*      height: "42px",*/}
                      {/*      border: "2px solid #e0e6e8"*/}
                      {/*    }}*/}
                      {/*  />*/}
                      {/*</div>*/}

                      <div>
                        <label style={{ fontSize: "20px" }}>
                          <Text content={Messages.hospital_code} />
                        </label>

                        <input
                          style={{
                            height: "42px",
                            textAlign: "center",
                            fontSize: "20px",
                            letterSpacing: "3px",
                            borderWidth: "2px",
                            borderRadius: "4px"
                          }}
                          ref={attrEl => {
                            this.inputEl = attrEl;
                          }}
                          className="form-control"
                          type="text"
                          value={facilityCode}
                          onChange={e => {
                            this.setState({ facilityCode: e.target.value });
                          }}
                          autoComplete="nope"
                        />
                      </div>

                      <div className="d-flex mt-3">
                        <Button
                          size="lg"
                          color="primary"
                          className="px-4"
                          disabled={!facilityCode}
                          style={{
                            cursor: !facilityCode ? "default" : "pointer",
                            width: "100%"
                          }}
                        >
                          <Text content={Messages.continue} />
                        </Button>
                      </div>
                    </form>

                    <div className="mt-5" style={{ fontSize: "13px" }}>
                      <p>
                        <Text content={Messages.contact_the_organization} />
                      </p>
                      <p
                        style={{
                          fontWeight: 500,
                          backgroundColor: "#f1f1f1",
                          padding: "5px"
                        }}
                      >
                        <Text content={Messages.invite_you_received} />
                      </p>
                      <p>
                        <Text content={Messages.please_contact} />{" "}
                        <a href="mailto:support@mypatientspace.zendesk.com">
                          {/*support@mypatientspace.com*/}
                          <Text content={Messages.myPatientSpace_support} />
                        </a>
                        .
                      </p>
                    </div>

                    <SignupFooter />
                  </CardBody>
                </Card>
              </CardGroup>

              <div className="my-4 d-flex justify-content-center align-items-center">
                <div>
                  <RegionSelector
                    className="drop-up"
                    style={{
                      backgroundColor: "#f7f7f7",
                      border: 0,
                      width: 65,
                      height: 30
                    }}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
